import type { NewUserQuizPayload, NewUserQuizStatus, NewUserQuizSubmitResponse } from './types';

import { BASE_URL } from '../constants';
import { get, post } from '../requestMethods';

const NEW_USER_QUIZ_URL = `${BASE_URL}/api/survey/new-user-quiz`;

export const NEW_USER_QUIZ_API = {
  submit: (data: NewUserQuizPayload) => post<NewUserQuizSubmitResponse>(NEW_USER_QUIZ_URL, { data }),
  getStatus: () => get<NewUserQuizStatus>(`${NEW_USER_QUIZ_URL}/status`),
};

export type {
  ContentTeamSize,
  LocalizationFrequency,
  NewUserQuizPayload,
  NewUserQuizPriority,
  NewUserQuizStatus,
  NewUserQuizSubmitResponse,
  TargetLanguageCount,
} from './types';
